import React from 'react';
import * as Render from '../Base/Render';
import classNames from 'classnames';

const View = (props) => {
  const cssNames = classNames({
    'c-chapter-container': true,
    'c-chapter-container--is-nav': props.isNav && props.AnchorSectionId,
  });

  const dataPrintSidebarTitle = props.Heading || '';

  return (
    <div
      className={cssNames}
      id={!props.isNav ? props.AnchorSectionId : undefined}
      data-print-sidebar-title={dataPrintSidebarTitle}
      data-chapter-container={'data-chapter-container'}
    >
      {props.Heading && <h2>{props.Heading}</h2>}
      <Render.Block
        blocks={props.Content}
        propertyName="Content"
        currentPageProps={props.CurrentPageProps}
      >
        <Render.BlockTypeRenderer
          isH3={props.Heading}
          isMemberOfChapterContainer={true}
          Blocks={props.Blocks}
        />
      </Render.Block>
    </div>
  );
};

export default View;
